import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {graphql} from "react-apollo/lib/index";
import {connect} from "react-redux";
import ScanMutation from "../../graphql/ScanMutation.graphql";
import Message from "../../enums/Message";
import {actions as system} from "../../reducers/system";

@connect(
    state => {

    },
    dispatch => {
        return {
            addMessage: (message) => dispatch(system.addMessage(message)),
        }
    })
@graphql(
	ScanMutation, {
		name: 'scan'
	}
)
export default class ScanButton extends Component {

	static propTypes = {
		status: PropTypes.object,
		data: PropTypes.object,
		selectedProject: PropTypes.object,
	};

	scanProject(project) {
		this.props.scan({
			variables: {
				input: {
					projectName: project.name
				}
			}
		}).then(
		    result => {
                this.props.data.refetch({
                    variables: {
                        project: this.props.selectedProject.name
                    }})
            },
            error => {
		        console.log(error)
                this.props.addMessage(new Message(
                    Message.TYPE_ERROR,
                    500,
                    'Could not scan: ' + error.message
                ));
            }
		)
	}

	render() {
		const {status, selectedProject} = this.props;

		return (
			<button onClick={() => this.scanProject(selectedProject)}
					disabled={status.project.codeScan?status.project.codeScan.isRunning:null} className="btn btn-primary">Scan
			</button>
		);
	}
}



// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/ScanButton.js